import axios from 'axios';


export default {
    getComposition: (url) => {
        if (!url) return Promise.reject("url is not supported");
        return axios.get(url);
    }
}

